import { useEffect, useState, FC } from 'react';
import { useSpring, animated } from 'react-spring';
import { useRaf, useIdle } from 'react-use';
import ReactTooltip from 'react-tooltip';

import styles from './BackToTop.module.scss';

export const BackToTop: FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolling, setScrolling] = useState(false);
  const [initialY, setInitialY] = useState(0);
  const isIdle = useIdle(500);
  const [time, setTime] = useState(0);
  const done = useRaf(time);
  const { opacity } = useSpring({ opacity: isVisible ? 1 : 0 });

  useEffect(() => {
    if (isScrolling) {
      window.scroll(0, initialY * (1 - done));
    }
    if (done === 1) {
      setTime(0);
      setInitialY(0);
      setScrolling(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [done]);

  useEffect(() => {
    if (isIdle) {
      const { scrollY } = window;

      if (scrollY > 0 && !isVisible) {
        setIsVisible(true);
      } else if (scrollY <= 0 && isVisible) {
        setIsVisible(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIdle]);

  function scrollTop() {
    if (!isScrolling) {
      const { scrollY } = window;

      setScrolling(true);
      setInitialY(scrollY);
      setTime(400);
    }
  }

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <animated.button
        data-tip="React-tooltip"
        data-for="back-to-top-tooltip"
        type="button"
        className={styles.ButtonUp}
        onClick={scrollTop}
        style={{ opacity }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7.5" fill="none" width="18px" height="13px">
          <polygon
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            points="9.03,7.5 5.51,3.97 1.98,7.5 0,5.52 5.51,0 11,5.51 "
          />
        </svg>
      </animated.button>
      <ReactTooltip className={styles.Tooltip} place="left" type="dark" effect="solid" id="back-to-top-tooltip">
        <span>Наверх</span>
      </ReactTooltip>
    </>
  );
};
